import React from 'react';

export default function PurchaseOrderCustomPriceTable(props) {
    return (
        <div className="inbud-table_wrapper">
            <table className="inbud-table">
                <thead>
                    <tr>
                        <th className="!tw-bg-charcoal-25">{$t('Original Custom Price by Venues')}</th>
                        <th className="!tw-bg-charcoal-25">{$t('Revised Custom Price by Venues')}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr className="tw-bg-[#f6f6f6]">
                        <td className="tw-font-mono">
                            {props.row.original_custom_prices.map((price, i) => {
                                return (
                                    <p key={`${props.prefix}-row-${props.index}-original-price-${i}`}>
                                        {price.name}: {price.amount}
                                    </p>
                                );
                            })}
                        </td>
                        <td className="tw-font-mono">
                            {props.row.revised_custom_prices.map((price, i) => {
                                return (
                                    <p key={`${props.prefix}-row-${props.index}-revised-price-${i}`}>
                                        {price.name}: {price.amount}
                                    </p>
                                );
                            })}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}
